const colors = {
    white: '#fff',
    smalt: '#003399',
    mineShaft: '#232323',
    magnolia: '#FCFBFF',
};

export default colors;